export default __webpack_public_path__ + "static/media/341.1f74b0f0.png";